import { MutationTree } from 'vuex';
import { ErrorDetail } from '../../../types';
import { NodeIdpAccountState } from './types';
import { Account } from '../../account/types';
import * as types from './mutation-types';

// IdPアカウント追加のエラーをクリアする
const resetChangesAllErrors = (state: NodeIdpAccountState): void => {
    const searchState = state.search;
    searchState.error = false;
    searchState.errorCode = undefined;
    searchState.errorMsg = undefined;

    const createState = state.create;
    createState.error = false;
    createState.errorTitle = undefined;
    createState.errorDetails = undefined;

    const destroyState = state.destroy;
    destroyState.error = false;
    destroyState.errorTitle = undefined;
    destroyState.errorDetails = undefined;
};

export const mutations: MutationTree<NodeIdpAccountState> = {
    // ノードIdPアカウント一覧系
    [types.SEARCH_START](state) {
        resetChangesAllErrors(state);
        const searchState = state.search;
        searchState.error = false;
        searchState.errorCode = undefined;
        searchState.errorMsg = undefined;
        searchState.isProcessing = true;
        searchState.isFetchSuccess = false;
    },

    [types.SEARCH_SUCCESS](state, payload: { count: number; idp_accounts: Array<Account> }) {
        state.idpAccountCount = payload.count;
        state.idpAccounts = payload.idp_accounts;

        const searchState = state.search;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = true;
    },

    [types.SEARCH_FAILURE](state, payload: { code: string; message: string }) {
        const searchState = state.search;
        searchState.errorCode = payload.code;
        searchState.errorMsg = payload.message;
        searchState.error = true;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;
    },

    // IdPアカウント追加系
    [types.NEW_ACCOUNTS](state) {
        resetChangesAllErrors(state);
    },

    [types.CREATE_START](state) {
        resetChangesAllErrors(state);
        const createState = state.create;
        createState.isProcessing = true;
    },

    [types.CREATE_SUCCESS](state) {
        const createState = state.create;
        createState.isProcessing = false;
    },

    [types.CREATE_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const createState = state.create;
        createState.errorTitle = payload.errorTitle;
        createState.errorDetails = payload.errorDetails;
        createState.error = true;
        createState.isProcessing = false;
    },

    // IdPアカウント削減系
    [types.DESTROY_START](state) {
        resetChangesAllErrors(state);
        const destroyState = state.destroy;
        destroyState.isProcessing = true;
    },

    [types.DESTROY_SUCCESS](state) {
        const destroyState = state.destroy;
        destroyState.isProcessing = false;
    },

    [types.DESTROY_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const destroyState = state.destroy;
        destroyState.errorTitle = payload.errorTitle;
        destroyState.errorDetails = payload.errorDetails;
        destroyState.error = true;
        destroyState.isProcessing = false;
    },

    // FATALエラー系
    [types.FATAL_FAILURE](state) {
        const searchState = state.search;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;

        const createState = state.create;
        createState.isProcessing = false;

        const destroyState = state.destroy;
        destroyState.isProcessing = false;
    },

    [types.CLEAR_ALL](state) {
        resetChangesAllErrors(state);

        state.idpAccounts = undefined;
        state.idpAccountCount = 0;
    },
};
